"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIDropdownCaret = _interopRequireDefault(require("../../dropdown/UIDropdownCaret"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_UIDropdownCaret.default).withConfig({
  displayName: "SimpleStyledCaret",
  componentId: "sc-1wzds62-0"
})(_templateObject(), _colors.EERIE);

exports.default = _default;
module.exports = exports.default;